export const drawLocalSetting = (ln_t) => ({
  draw: {
    toolbar: {
      actions: {
        title: ln_t('util.edit'),
        text: ln_t('util.cancel')
      },
      finish: {
        title: '',
        text: ''
      },
      undo: {
        title: ln_t('util.cancel'),
        text: ln_t('util.cancel')
      },
      buttons: {
        polyline: '',
        polygon: '',
        rectangle: '',
        circle: ln_t('location.drawCircle'),
        marker: '',
        circlemarker: ''
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: ''
        },
        radius: ln_t('location.radius')
      },
      circlemarker: {
        tooltip: {
          start: ''
        }
      },
      marker: {
        tooltip: {
          start: ''
        }
      },
      polygon: {
        tooltip: {
          start: '',
          cont: '',
          end: ''
        }
      },
      polyline: {
        error: '',
        tooltip: {
          start: '',
          cont: '',
          end: ''
        }
      },
      rectangle: {
        tooltip: {
          start: ''
        }
      },
      simpleshape: {
        tooltip: {
          end: ''
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: ln_t('util.save'),
          text: ln_t('util.save')
        },
        cancel: {
          title: ln_t('util.cancel'),
          text: ln_t('util.cancel')
        },
        clearAll: {
          title: ln_t('location.clearAll'),
          text: ln_t('location.clearAll')
        }
      },
      buttons: {
        edit: ln_t('util.edit'),
        editDisabled: ln_t('location.noEditableLayers'),
        remove: ln_t('util.delete'),
        removeDisabled: ln_t('location.noLayersToDelete')
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: `${ln_t('location.dragMiddleInfo')}<br/>${ln_t('location.dragPeripheralInfo')}`,
          subtext: ''
        }
      },
      remove: {
        tooltip: {
          text: ''
        }
      }
    }
  }
})
